import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { CTSType } from "fond/types";

import { CTS_TYPE_OPTIONS } from "./costChartUtils";

interface CtsTypeSelectProps {
  value: CTSType;
  onChange(value: CTSType): void;
}

const CtsTypeSelect: React.FC<CtsTypeSelectProps> = ({ value, onChange }) => {
  const handleChange = (event: SelectChangeEvent) => onChange(event.target.value as CTSType);

  return (
    <Select value={value} onChange={handleChange} size="small" margin="dense" sx={{ width: 176 }} inputProps={{ "aria-label": "Cost type" }}>
      {CTS_TYPE_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CtsTypeSelect;
